/* eslint-disable jsx-a11y/anchor-has-content */
import { getAnalyticTags } from "core/lib/analytics-methods";
import { NewsArticlePackage } from "core/types";
import dateWrapper from "core/lib/date-wrapper";
import Loader from "components/loader/loader";

type NewsArticlesProps = {
  articles: NewsArticlePackage[],
  loading: boolean
}
const NewsArticles = (props: NewsArticlesProps) => {
  const { articles, loading } = props;

  if (!articles.length) {
    return null;
  }

  if (loading) {
    return (<Loader />);
  }

  return (<div className="article-holder container mt-4" id="news-articles" style={{ zIndex: 1 }}>
    {articles?.map((article, ix) => {
      const analytics = getAnalyticTags({
        component_name: "news_card",
        component_type: "cta",
        cta_text: "news_article",
        target_page_url: article.url
      });

      const { url, categoryIconClass, categoryName, publishedDate, headline, excerpt, headlineImage } = article;

      const date = dateWrapper(publishedDate).doubleDigitDayFullMonthAndYear;

      const style = { backgroundImage: `url(${headlineImage}?width=550)` };

      return (
        <div key={ix} className="col-12 col-md-6 col-lg-4 col-xl-3">
          <div className="card article-card px-0 pt-0 pb-2">
            <div className="lozad article-card-image border border-transparent rounded-top" style={style}>
            </div>
            <div className="card-body sameCardHeight" style={{ height: 213 }}>
              <div className="article-description">
                <span className={categoryIconClass}></span>
                <strong className="mr-auto">{categoryName}</strong>
                <span className="date">{date}</span>
              </div>
              <strong className="card-title title-clamp-2">{headline}</strong>
              <p className="card-text title-clamp-3">{excerpt}</p>
            </div>
            <a
              href={url}
              className="sr-only card-link"
              target="_blank"
              rel="noreferrer"
              {...analytics}
            ></a>
          </div>
        </div>
      );
    })}

  </div>);
}

export default NewsArticles;
